import { Injectable } from '@angular/core';
import { AmdocsAppsyncClientService, AmdocsAuthService, AmdocsFunctionsService, AmdocsTimeService } from 'amdocs-auth-package';
import { ApiError } from 'amdocs-core-package';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { CONSTANTS } from '../constants';
import { ApiService } from '../core/api.service';

@Injectable()

export class TimeZoneService {

  private tzDateFormat = 'DD-MM-YYYY';
  constructor(
    private appSyncClient: AmdocsAppsyncClientService,
    private apiService: ApiService,
    private amdocsAuthService: AmdocsAuthService,
    private amdocsTimeService: AmdocsTimeService,
    private amdocsFunctionsService: AmdocsFunctionsService) {
  }


  public getReportedTime(): Observable<ITimeZoneWeek> {
    const transactionId = this.amdocsFunctionsService.createGuid();
    const TZQueryInput = {
      TransactionId: transactionId,
      AgentType: CONSTANTS.TIME_ZONE.AGENT_TYPE,
      ScreenID: CONSTANTS.TIME_ZONE.SCREEN_ID,
      IdToken: this.amdocsAuthService.getToken(),
      Data: [
        {
          WEEK: {
            DATE:  this.amdocsTimeService.moment().format(this.tzDateFormat),
            FROM_WEEK: CONSTANTS.TIME_ZONE.FROM_WEEK,
            TO_WEEK: CONSTANTS.TIME_ZONE.TO_WEEK,
            GET_EMP_DETAILS: CONSTANTS.TIME_ZONE.GET_EMP_DETAILS
          }
        }
      ]
    };
    return this.apiService.getReportedTime(TZQueryInput).pipe(
      mergeMap((response: any) => {
        if (response.TransactionStatus === 'S') {
          const week: ITimeZoneWeek = response.Data[0].WEEK[0];
          return of(week);
        }
        return throwError(() => new ApiError(-1, response.TransactionMessage));
      })
    );
  }

  public saveHour(clockIn: string, clockOut: string, week: ITimeZoneWeek): Observable<ITimeZoneWeek> {
    const lineNumber = week.DAYS[0]?.REP_DATE?.LINES[0]?.LINE_NO || null;
    let lineAction = lineNumber ? 'U' : 'I';
    if (!clockIn && !clockOut) {
      clockOut = '';
      clockIn = '';
      lineAction = 'D';
    }
    const transactionId = this.amdocsFunctionsService.createGuid();

    const TZQueryInput = {
      TransactionId: transactionId,
      AgentType: CONSTANTS.TIME_ZONE.AGENT_TYPE,
      ScreenID: CONSTANTS.TIME_ZONE.SCREEN_ID,
      IdToken: this.amdocsAuthService.getToken(),
      Data: [
        {
          WEEK: {
            WEEK_NO: week.WEEK_NO,
            WEEK_STATE: CONSTANTS.TIME_ZONE.WEEK_STATE,
            WEEK_APPROVED: CONSTANTS.TIME_ZONE.WEEK_APPROVED,
            WEEK_START: week.WEEK_START,
            WEEK_END: week.WEEK_END,
            DAYS: [
              {
                REP_DATE: {
                  DATE: this.amdocsTimeService.moment().format(this.tzDateFormat),
                  ABSENCE_HOURS: CONSTANTS.TIME_ZONE.ABSENCE_HOURS,
                  ABSENCE_LINES: [],
                  LINES: [
                    {
                      LINE_ACTION: lineAction,
                      IN: clockIn,
                      OUT: clockOut,
                      LINE_NO: lineNumber ? lineNumber : null,
                      TMP_ID: !lineNumber ? this.amdocsFunctionsService.createGuid() : null
                    }
                  ],
                  WORK_TYPE: CONSTANTS.TIME_ZONE.WORK_TYPE,
                  top: CONSTANTS.TIME_ZONE.TOP
                }
              }
            ]
          }
        }
      ]
    };
    return this.apiService.saveHour(TZQueryInput).pipe(
      mergeMap((response: any) => {
        if (response.TransactionStatus === 'S') {
          return of(response.Data[0].WEEK);
        }
        return throwError(() => new ApiError(-1, response.TransactionMessage));
      })
    );
  }
}

export enum StateModeTypes {
  empty = 'empty-state',
  checkedIn = 'checked-in',
  afterCheckout = 'after-checkout',
  editingAfterCheckout = 'editing-after-checkout',
  full = 'full-state',
}

export interface ITimeZoneWeek {
  WEEK_APPROVED: string;
  WEEK_END: string;
  WEEK_NO: string;
  WEEK_START: string;
  WEEK_STATE: string;
  DAYS: {REP_DATE: ITimeZoneDay}[];
}

export interface ITimeZoneDay {
  ABSENCE_HOURS?: number;
  DATE?: string;
  ABSENCE_LINES?: ITimeZoneDayAbsenceLine[];
  LINES?: ITimeZoneDayPresenceLine[];
}

export interface ITimeZoneDayAbsenceLine {
  ABSENCE_CODE: string;
  ABSENCE_DESC: string;
  NEGATIVE: boolean;
  ABSENCE_HOURS: number;
  ICON: string;
  LOCKED: boolean;
}

export interface ITimeZoneDayPresenceLine {
  LINE_NO: string;
  IN: string;
  OUT: string;
}
